<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-tabs v-model="tab" centered icons-and-text fixed-tabs>
          <v-tabs-slider></v-tabs-slider>

          <!--  KUF TAB  -->
          <v-tab href="#tab-1" v-if="this.$config.Kuf">
            {{ $t('kufShort') }}
            <v-icon>description</v-icon>
          </v-tab>

          <!--  KIF TAB  -->
          <v-tab href="#tab-2">
            {{ $t('kifShort') }}
            <v-icon>feed</v-icon>
          </v-tab>

          <!--  FEE TAB  -->
          <v-tab href="#tab-3"  v-if="feesPermission">
            {{ $t('feeReport') }}
            <v-icon>summarize</v-icon>
          </v-tab>

          <!--  OperaterReports TAB  -->
          <v-tab href="#tab-4" disabled>
            {{ $t('operatorReport') }}
            <v-icon>table_chart</v-icon>
          </v-tab>

          <!--  IndividualVatRecordReport TAB  -->
          <v-tab href="#tab-5" v-if="individualVatRecordPermission">
            {{ $t('individualVatRecord') }}
            <v-icon>table_chart</v-icon>
          </v-tab>

          <!--  GroupVatRecordReport TAB  -->
          <v-tab href="#tab-6" v-if="groupVatRecordPermission">
            {{ $t('groupVatRecord') }}
            <v-icon>table_chart</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!--  KUF TAB Content -->
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-card-text>
                <KufReports />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!--  KIF TAB Content -->
          <v-tab-item value="tab-2">
            <v-card flat>
              <v-card-text>
                <KifReports />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!--  FEE TAB Content -->
          <v-tab-item value="tab-3" v-if="feesPermission">
            <v-card flat>
              <v-card-text>
                <FeeReports />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!--  OperaterReports Content -->
          <v-tab-item value="tab-4">
            <v-card flat>
              <v-card-text>
                <OperaterReports />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!--  IndividualVatRecordReport Content -->
          <v-tab-item value="tab-5" v-if="individualVatRecordPermission">
            <v-card flat>
              <v-card-text>
                <IndividualVatRecordReport />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!--  GroupVatRecordReport Content -->
          <v-tab-item value="tab-6" v-if="groupVatRecordPermission">
            <v-card flat>
              <v-card-text>
                <GroupVatRecordReport />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import KufReports from "../components/KufReports.vue";
import KifReports from "../components/KifReports.vue";
import FeeReports from "../components/FeeReports.vue";
import OperaterReports from "../components/OperaterReports.vue";
import IndividualVatRecordReport from "../components/IndividualVatRecordReport.vue";
import GroupVatRecordReport from "../components/GroupVatRecordReport.vue";

export default {
  name: "Reports",
  components: {
    KufReports,
    KifReports,
    FeeReports,
    OperaterReports,
    IndividualVatRecordReport,
    GroupVatRecordReport
  },
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    selectedOrganization() {
      return this.$store.getters.organizationId;
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
    feesPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'Fees' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    individualVatRecordPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'IndividualVatRecord' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    groupVatRecordPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'GroupVatRecord' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    }
  }
};
</script>

<style scoped>
</style>
